import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AdminFormService } from '../../control/admin-form.service';
import { FormSummary } from '../../entity/admin-form.model';
import { LocalizationPipePipe } from '../../../localization/control/localisation-pipe-pipe';
import { LocalizationService } from '../../../localization/control/localization.service';

@Component({
  selector: 'app-form-list',
  standalone: true,
  imports: [CommonModule, RouterLink, LocalizationPipePipe],
  templateUrl: './form-list.html',
  styleUrl: './form-list.scss'
})
export class FormList implements OnInit {
  forms: FormSummary[] = [];
  loading = true;
  error?: string;

  constructor(
    private readonly adminFormService: AdminFormService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly localizationService: LocalizationService
  ) {
  }

  ngOnInit(): void {
    this.loadForms().then();
  }

  private async loadForms(): Promise<void> {
    try {
      const allForms = await this.adminFormService.listForms();
      this.forms = allForms.filter(f => f.status !== 'deleted');
    } catch (err: unknown) {
      this.error = err instanceof Error ? err.message : this.localizationService.getTranslation('admin.forms.error.load');
    } finally {
      this.loading = false;
      this.changeDetectorRef.detectChanges();
    }
  }
}
